<template>

  <div>

    <div style="height: 100px;"></div>

    <div class="container text-center">

      <h1>Loading...</h1>

    </div>

    <div style="height: 75px;"></div>

  </div>

</template>

<script>
import axios from "axios";

import Auth from "../misc/Auth.js";

export default {
  mounted() {
    // dont use that anymore coz its confusing
    // @todo implement usefull debugging logger here
    //this.showConfirm(); 
    Auth.logout();
  },
  methods: {
    showConfirm() {
      this.$bvModal
        .msgBoxConfirm("Wollten Sie wirklich ausgeloggt werden?", {
          title: "Es gab ein Problem mit der Authentifizierung.",
          size: "md",
          buttonSize: "md",
          okVariant: "danger",
          cancelVariant: "primary",
          okTitle: "Ja, Raus hier!",
          cancelTitle: "Nein, zurück",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((isConfirmed) => {
          if (isConfirmed) {
            Auth.logout();
          } else {
            console.log("auth key:", localStorage.getItem("auth_key"));
            console.log("auth token:", localStorage.getItem("auth_token"));
            console.log("axios default headers", axios.defaults.headers);
            this.$router.back();
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
  },
};
</script>
